/* @flow */
import { getterFromKeyPath } from 'trustar/utils';
import { createSelector } from 'reselect';
import { OrderedMap, List } from 'immutable';
import { ACTIVE, PENDING } from './types';

import { credentialsTypes } from 'modules/miscellaneous/getters.js';

// getters from key path
export const feedsMap = getterFromKeyPath(['dataFeeds', 'feeds']);
export const loading = getterFromKeyPath(['dataFeeds', 'loading']);

/* Grab specific feed based on given guid */
export const feed = (guid: string) => {
  return createSelector(
    feedsMap,
    (feeds: OrderedMap<any, any>) => feeds.get(guid),
  );
};

/* Generate initial form values for save/edit enclave subscription modal */
export const getCredentialObject = (id: string) => createSelector(
  [feed(id), credentialsTypes],
  (feed, credentialsTypes) => {
    return credentialsTypes.get(feed.get('credentialsType'));
  }
);



// WEBPACK FOOTER //
// ./src/app/modules/data-feeds/getters.js